var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import Icon from '../../Styles/Icons/Icon';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
const IconButtonStyle = styled.button `
  border-style: none;
  height: auto;
  cursor: pointer;
  position: relative;
  display: inline-block;
  text-align: center;
  transition: background-color 400ms ease-in-out;
  padding: ${props => props.noPadding ? '0rem' : props.theme.paddingsMargins.inputsPadding};
  background-color: transparent;
  border-radius: 50%;
  ${props => props.mediaQuery};
  ${(props) => props.hoverEffect && !props.isLoading &&
    css `
      &:hover {
        border-radius: 50%;
        background-color: ${(props) => props.theme.utils.getColor(props.backgroundColor) + '22'};
      }
    `};
  ${(props) => props.isDisabled &&
    css `
      cursor: not-allowed;
      border-radius: 50%;
      background-color: ${props.theme.colors.greyColor};
      &:hover {
        border-radius: 50%;
        background-color: ${props.theme.colors.greyColor};
      }
    `};
`;
const IconButton = (_a) => {
    var { onClick, onMouseEnter, secondary = false, icon, size = 'article', noPadding = false, color = 'main', hoverEffect = true, isDisabled = false, skeleton, isLoading, mediaQuery, excludeMeFromLoadingContext = false, iconMediaQuery } = _a, props = __rest(_a, ["onClick", "onMouseEnter", "secondary", "icon", "size", "noPadding", "color", "hoverEffect", "isDisabled", "skeleton", "isLoading", "mediaQuery", "excludeMeFromLoadingContext", "iconMediaQuery"]);
    const { loadingContext } = useCronoSkeleton();
    return (_jsx(IconButtonStyle, Object.assign({ hoverEffect: hoverEffect, backgroundColor: secondary ? 'secondary' : color, onClick: isDisabled || isLoading ? () => { } : onClick, onMouseEnter: onMouseEnter, isDisabled: isDisabled, noPadding: noPadding, isLoading: isLoading ? 'true' : '', mediaQuery: mediaQuery }, props, { children: isLoading
            ? _jsx(Skeleton, Object.assign({ height: size, width: size, margin: "vh" }, skeleton))
            : _jsx(Icon, { isLoading: isLoading || (loadingContext && excludeMeFromLoadingContext === false), isDisabled: isDisabled, cursor: isDisabled ? 'not-allowed' : 'pointer', icon: icon, size: size, color: secondary ? 'secondary' : color, mediaQuery: iconMediaQuery }) })));
};
export default IconButton;
